import { render, staticRenderFns } from "./Wallets.vue?vue&type=template&id=d105ca48&scoped=true&"
import script from "./Wallets.vue?vue&type=script&lang=js&"
export * from "./Wallets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d105ca48",
  null
  
)

export default component.exports